import { render } from "./Contributors.vue?vue&type=template&id=2eaeed33"
import script from "./Contributors.vue?vue&type=script&lang=js"
export * from "./Contributors.vue?vue&type=script&lang=js"

import "./Contributors.vue?vue&type=style&index=0&id=2eaeed33&lang=css"

import exportComponent from "/home/runner/work/web/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__